module.exports = __webpack_public_path__ + "img/S511.2dee5e26.jpg";